<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16.964" viewBox="0 0 24 16.964">
    <path id="多角形_13" data-name="多角形 13" d="M12,0,24,16.964H0Z" :transform="'translate(24 16.964) rotate(' + rotate + ')'" fill="currentColor"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'Triangle',

  props: {
    rotate: {
      type: Number,
      default: 0
    },
  }
})
</script>

<style lang="scss" scoped>
</style>
